import { useQuery } from '@tanstack/react-query';

import { toApiDateRange } from '../../../lib/dateRange';
import type { DashboardNotesResponse, DashboardRateInput } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';
import { extranetQueryKeys } from '../queryKeys';

export const useDashboardNotes = (input: DashboardRateInput) =>
  useQuery({
    queryKey: extranetQueryKeys.dashboard.notes(input),
    queryFn: () =>
      getExtranetApi().get<DashboardRateInput, DashboardNotesResponse>('/v1/extranet/dashboard/notes', {
        ...input,
        dateRange: toApiDateRange(input.dateRange),
      }),
    enabled: Boolean(input.dateRange?.from && input.dateRange?.to),
  });
